import React from 'react';
import { useWebSettings } from '../../Context/WebSettings/WebSettingsContext';
import { Maintenance } from '../../Pages/Maintenance/Maintenance';
import { ServerError } from '../../Pages/ServerError/ServerError';
import { StatusPage } from '../StatusPage/StatusPage';
import { LoaderCircle } from 'lucide-react';
import styles from './Style.module.css';

export const ApplicationGate = ({ children }) => {
  const { isPending, isFetching, isPaused, failureCount, hasSettings, maintenanceMode, refetch } = useWebSettings();

  // Keep usable settings during background refreshes. Only initial loading
  // blocks booking routes, including requests paused while offline.
  if (!hasSettings) {
    if (isPending || isFetching) {
      const message = isPaused
        ? "Check your internet connection. Loading will continue when you're back online."
        : failureCount > 0
          ? 'Taking longer than usual. Still trying…'
          : 'Please wait while we load online booking.';

      return (
        <div role="status" aria-live="polite" aria-atomic="true">
          <StatusPage
            icon={<LoaderCircle className={isPaused ? undefined : styles.spinner} aria-hidden="true" />}
            heading={isPaused ? 'Waiting for a connection…' : 'Loading…'}
            description={message}
          />
        </div>
      );
    }
    return <ServerError onRetry={() => refetch()} />;
  }
  if (maintenanceMode) return <Maintenance />;
  return children;
};
